import { Map, fromJS } from 'immutable'
import { normalize } from 'normalizr'

import { aiIntegrationSchema, aiCorrectionSchema, aiModelSchema } from '_/models/ai-integration'
import { createReducer } from '_utils/redux'
import { getPage } from '_utils/helpers'
import { ORDER_BY_VALUES } from '_utils/constants'

import { GET_ASSISTANTS, GET_ERROR_CORRECTION, GET_AI_MODELS } from './actions'

const INITIAL_STATE = new Map({
  results: Map(),
  next: '',
  count: '',
  pageSize: 10,
  orderAssistants: new Map(),
  params: undefined,
  page: 0,
  isAsc: undefined,
})

export const aiAssistant = createReducer(INITIAL_STATE, {
  [GET_ASSISTANTS.FULFILLED]: (state, { payload, meta = {} }) => {
    const { order = ORDER_BY_VALUES.ASC } = meta
    const normalizeAIAssistants = normalize(payload.results, aiIntegrationSchema)

    return state
      .set('results', fromJS(normalizeAIAssistants.entities.aiAssistant))
      .set('next', getPage(payload.next))
      .set('count', payload.count)
      .set('pageSize', meta?.pageSize || 10)
      .set('params', { order: meta?.order })
      .set('page', meta?.page || 0)
      .set('orderAssistants', normalizeAIAssistants.result)
      .set('isAsc', order === ORDER_BY_VALUES.ASC)
  },
})

export const aiCorrections = createReducer(INITIAL_STATE, {
  [GET_ERROR_CORRECTION.FULFILLED]: (state, { payload, meta = {} }) => {
    const { order = ORDER_BY_VALUES.ASC } = meta
    const normalizeAICorrections = normalize(payload.results, aiCorrectionSchema)

    return state
      .set('results', fromJS(normalizeAICorrections.entities.aiCorrection))
      .set('next', getPage(payload.next))
      .set('count', payload.count)
      .set('pageSize', meta?.pageSize || 10)
      .set('params', { order: meta?.order })
      .set('page', meta?.page || 0)
      .set('order', normalizeAICorrections.result)
      .set('isAsc', order === ORDER_BY_VALUES.ASC)
  },
})

export const aiModels = createReducer(INITIAL_STATE, {
  [GET_AI_MODELS.FULFILLED]: (state, { payload, meta = {} }) => {
    const { order = ORDER_BY_VALUES.ASC } = meta
    const normalizeAIModels = normalize(payload.results, aiModelSchema)

    return state
      .set('results', fromJS(normalizeAIModels.entities.aiModel))
      .set('next', getPage(payload.next))
      .set('count', payload.count)
      .set('pageSize', meta?.pageSize || 10)
      .set('params', { order: meta?.order })
      .set('page', meta?.page || 0)
      .set('order', normalizeAIModels.result)
      .set('isAsc', order === ORDER_BY_VALUES.ASC)
  },
})
